import React from 'react'
import PropTypes from 'prop-types'
import { hourFromMinutes, canOpenAppointment, canCloseAppointment, canStartAppointment , canCompleteAppointment, canCancelAppointment, appointmentIsReserved } from 'lib/helper'
import './style.css'

import Text from 'components/Text'
import AppointmentStatusLabel from 'components/AppointmentStatusLabel'
import PaymentLabel from 'components/PaymentLabel'
import { PhoneNumber, CPF, Currency } from 'components/Formatter'
import { getPrettyDate, shouldShowPaymentMethod } from 'lib/helper'

const AppointmentCard = ({ appointment, onOpen, onClose, onStart, onComplete, onCancel }) => {

   const isAppointmentReserved = appointmentIsReserved(appointment)

   const resAppointment = appointment.dtoReservedAppointment
   let user
   if (isAppointmentReserved) {
      user = {
         fullName: resAppointment.clientFullName,
         birthday: getPrettyDate(resAppointment.clientBirthDate),
         gender: resAppointment.clientGender,
         cpf: resAppointment.billingCPF,
         email: resAppointment.clientEmail,
         // TODO: phones can be an array?
         phone: resAppointment.clientPhones,
      }
   }

   return (
      <div className={`AppointmentCard status-${appointment.appointmentStatus}`}>
         <div className="AppointmentCard-Info">
            <Field title="Horário" value={hourFromMinutes(appointment.appointmentTime)} />
            {/* Show user info if appointment is reserved */}
            {isAppointmentReserved ?
               <div>
                  <Field title="Nome" value={user.fullName} />
                  <Field title="Data de Nascimento" value={user.birthday} />
                  <Field title="Código da Consulta" value={resAppointment.appointmentCode} />
                  <Field title="CPF" value={<CPF>{user.cpf}</CPF>} />
                  <Field title="Telefone" value={<PhoneNumber>{user.phone}</PhoneNumber>} />
                  <Field title="E-mail" value={user.email} />
               </div>
               : null
            }
            <Field title="Status" value={<AppointmentStatusLabel appointment={appointment} />} />

            {shouldShowPaymentMethod(appointment) ?
               <div>
                  <Field title="Pagamento" value={<PaymentLabel appointment={appointment} />} />
                  <Field title="Valor" value={<Currency>{resAppointment.oneClickAppointmentValue}</Currency>} />
               </div>
               : null
            }
         </div>

         <div className="AppointmentCard-Controls">
            {canOpenAppointment(appointment) ? <span onClick={onOpen.bind(null, appointment)}>Abrir Horário</span> : null}
            {canCloseAppointment(appointment) ? <span onClick={onClose.bind(null, appointment)}>Fechar Horário</span> : null}
            {appointment.isTelehealth === true ?
               canStartAppointment(appointment) ?
                  <span onClick={onStart.bind(null, appointment)}>Atender</span>
                  :
                  null
               :
               canCompleteAppointment(appointment) ?
                  <span onClick={onComplete.bind(null, appointment)}>Finalizar</span>
                  :
                  null
            }
            {canCancelAppointment(appointment) ? <span onClick={onCancel.bind(null, appointment)}>Cancelar</span> : null}
         </div>
      </div>
   )
}

AppointmentCard.propTypes = {
   appointment: PropTypes.object.isRequired,
   onOpen: PropTypes.func,
   onClose: PropTypes.func,
   onCancel: PropTypes.func.isRequired,
   onComplete: PropTypes.func.isRequired,
   onStart: PropTypes.func.isRequired,
}

const Field = ({ title, value }) => (
   <Text><strong>{title}: </strong>{value}</Text>
)

export default AppointmentCard



// WEBPACK FOOTER //
// ./src/components/AppointmentCard/index.js